/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {useMutation} from 'react-query';
import {performScheduleDataSyncOperation} from '@ion/core/src/services/Connect';
import {GenericObject} from '@ion/core/src/types/entities';

export type UseScheduleDataSyncOperationResult = {
  process: (params: GenericObject, callbacks) => void;
  isProcessing: boolean;
}

/**
 * Hook for calling the schedule data sync API for force-updating devices.
 *
 * ```typescript
 *
 *  import {useScheduleDataSyncOperation} from '@ion/packages/query/src/hooks';
 *
 *  const {process, isProcessing} = useScheduleDataSyncOperation({
 *    id : populatedDevice?.id
 *  });
 *
 * ```
 */
export const useScheduleDataSyncOperation = (): UseScheduleDataSyncOperationResult => {
  const {mutate, isLoading} = useMutation(async({
    id
  }: GenericObject) => {
    return await performScheduleDataSyncOperation({
      ids : [id]
    });
  });

  return {
    process      : mutate,
    isProcessing : isLoading
  };
};

export default useScheduleDataSyncOperation;
